import {
  base_colorAction,
  base_colorContentBorder,
  base_colorRaisedSurface,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: ${spacing(8)} ${spacing(10)};
  background-color: ${base_colorRaisedSurface};
  border-radius: 24px;
  box-shadow: 0px 2px 12px 0px rgba(20, 20, 43, 0.08);
  border: 1px solid ${base_colorContentBorder};

  // VARIANTS
  // plain is default. No need to add additional variant classes

  &.highlight {
    border-color: ${base_colorAction};
  }
`
